import { render, staticRenderFns } from "./targetColumn.vue?vue&type=template&id=1b55db12&scoped=true&"
import script from "./targetColumn.vue?vue&type=script&lang=js&"
export * from "./targetColumn.vue?vue&type=script&lang=js&"
import style0 from "./targetColumn.vue?vue&type=style&index=0&id=1b55db12&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b55db12",
  null
  
)

export default component.exports